import { render, staticRenderFns } from "./Projects-fade-grid.vue?vue&type=template&id=fac9d914&"
import script from "./Projects-fade-grid.vue?vue&type=script&lang=ts&"
export * from "./Projects-fade-grid.vue?vue&type=script&lang=ts&"
import style0 from "./Projects-fade-grid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports